import { jsx as _jsx } from "react/jsx-runtime";
import { useFocusVisible } from "use-focus-visible";
import { StyledLi } from "./popupMenuItem.styles";
// utils
import { makeDataTestIdGetter } from "../../../utils";
export function PopupMenuItem({ name, isActive, onClick, disabled, isDisabled, url, dataTestIdPrefix, }) {
    const { focusVisible, onFocus, onBlur } = useFocusVisible();
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    return (_jsx(StyledLi, Object.assign({ className: disabled ? "disabled" : "", isActive: isActive, isDisabled: isDisabled, focusVisible: !isDisabled && focusVisible, onFocus: onFocus, onBlur: onBlur, role: "none", onClick: (ev) => {
            if (typeof onClick === "function") {
                if (!isDisabled) {
                    onClick();
                }
                ev.stopPropagation();
            }
            ev.preventDefault();
        }, onKeyDown: () => { }, "data-testid": getDataTestId("popupmenu-item-input") }, { children: _jsx("a", Object.assign({ role: "menuitem", href: url, tabIndex: 0 }, { children: name })) })));
}
